import React from 'react';

import { ChipsList } from '@/components/ChipsList';
import { Seed } from '@/types';

interface TagsCellProps {
  seed: Seed;
}

/**
 * Memoized cell renderer for tags column in seeds table
 *
 * Features:
 * - Shows first tag with "+N" counter for additional tags
 * - Hovering anywhere in the cell shows all tags in tooltip
 * - Matches Technology and Assets TagsCell pattern
 *
 * @param seed - The seed to render tags for
 */
export const TagsCell: React.FC<TagsCellProps> = React.memo(({ seed }) => {
  const tags = seed.tags || [];

  if (!tags.length) return <>-</>;

  return (
    <ChipsList
      items={tags}
      maxVisible={1}
      variant="filter"
      size="xs"
      data-testid="seed-tags"
      wrapInTooltip
    />
  );
});

TagsCell.displayName = 'TagsCell';
